// Sprekerskleuren en -labels voor transcripten. Elke spreker krijgt een vaste,
// op wit goed leesbare kleur en een leesbaar label "Spreker N" i.p.v. het rauwe
// whisperx-label (SPEAKER_00). Toekenning op volgorde van eerste voorkomen
// binnen de meegegeven sprekerlijst (per belangentafel uniek).
export const SPREKER_KLEUREN = [
  '#1c6fb0', '#c0392b', '#1e7d34', '#6c3fb5',
  '#b8860b', '#0e7c86', '#b03a86', '#59631a',
];

// Unieke sprekers op volgorde van eerste voorkomen.
export function uniekeSprekers(segmenten) {
  return [...new Set((segmenten || []).map(s => s.spreker).filter(Boolean))];
}

export function sprekerKleur(spreker, sprekers) {
  const i = sprekers.indexOf(spreker);
  return SPREKER_KLEUREN[Math.max(0, i) % SPREKER_KLEUREN.length];
}

export function sprekerLabel(spreker, sprekers) {
  const i = sprekers.indexOf(spreker);
  return i >= 0 ? `Spreker ${i + 1}` : 'Spreker';
}
